import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
    code:""
   
    
}
const mutations={
   
    
    getAreaData(state,value){
        
        
     
        post(urls.admin.area.index,value).then((result)=>{
          console.log(result)  
          state.result=result
         
          
          
       
        
       
           
        });
        
    },
    getAreaUserData(state,value){
        
        
     
        post(urls.admin.area.get_user,value).then((result)=>{
         
         
          state.result=result
         
          
          
       
        
       
           
        });
        
    },
    addAreaUserData(state,value){
        
        
     
        post(urls.admin.area.add,value).then((result)=>{
         
         
          state.code=result
         
          
          
       
        
       
           
        });
        
    },
    getAreaList(state,value){



        post(urls.admin.area.list,value).then((result)=>{


            state.result=result







        });

    }

}
const  actions={
    getAreaDataAction(context,value){
       
        context.commit("getAreaData",value)
       
    },
    getAreaUserDataAction(context,value){
       
        context.commit("getAreaUserData",value)
       
    },
    addAreaUserDataAction(context,value){
       
        context.commit("addAreaUserData",value)
       
    },
    getAreaListAction(context,value){

        context.commit("getAreaList",value)

    },
  
    
   

}

export default {state,mutations,actions}